require("!!C:\\build\\node_modules\\script-loader\\addScript.js")(require("!!C:\\build\\node_modules\\raw-loader\\index.js!C:\\build\\node_modules\\buble-loader\\index.js??ref--1!C:\\build\\node_modules\\eslint-loader\\index.js!C:\\build\\resources\\assets\\scripts\\old\\lity.min.js"))


//////////////////
// WEBPACK FOOTER
// C:/build/~/script-loader!./scripts/old/lity.min.js
// module id = 26
// module chunks = 0